export default __webpack_public_path__ + "static/media/paper.a6e06a72.svg";